import React, { useState, useMemo, useContext } from "react";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import UploadAuthorization from "./UploadAuthorization";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import {getSite} from "services/ConfigServices";

export default function useEntitesTable(props) {
  // Though this is a GET, use a POST & method override because the sorted and
  // filtered params are complex (arrays of objects) for easier parsing.
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [totalRows, setTotalRows] = useState(0);

  const url = getSite(chartIdGroup,"contact");

  const { results, loading, error, refetch, invalidate } = useApi(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserService.getToken()}`,
    },
  });
  console.log(results);

  // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const StyledTextField = styled.input`
    height: 32px;
    width: 200px;
    border: 0px;
    padding: 0 32px 0 16px;
    &:hover {
      cursor: text;
    }
  `;

  const ClearButton = styled.button`
    border: 0px solid rgba(0, 0, 0, 0.15);
    border-left: 0px;
    background-color: none;
    height: 34px;
    width: 32px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
    }
  `;

  const SearchContainer = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const UploadButton = styled.div`
    margin-left: 15px;
    &:hover {
      cursor: pointer;
    }
  `;

  const TableName = styled.h1`
    margin-right: auto;
    margin-left: -8px;
    font-size: 1.3rem;
    font-weight: 500;
  `;

  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        {/*<PublishIcon fontSize="medium" />
        <UploadText>Import</UploadText>*/}
        <UploadAuthorization
          type="button"
          onClick={onUpload}
          refetch={refetch}
        />
      </UploadButton>
    </>
  );

  const filteredItems = _.get(results, "detail.contact.contactlist", []).filter(
    (item) =>
      (item.name &&
        item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.status &&
        item.status.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.role &&
        item.role.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.key && item.key.toLowerCase().includes(filterText.toLowerCase()))
  );

  console.log(filteredItems);

  const subHeaderComponentMemo = useMemo(() => {
    const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    //setTimeout(() => document.getElementById(`search`).focus());

    return (
      <>
        <FilterComponent
          key="FilterComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {realestateupdate ? <UploadComponent key="UploadComponent" onUpload={handleClear} /> : <></>}
      </>
    );
  }, [filterText, resetPaginationToggle]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
      loading,
    },
    error,
    refetch,
    invalidate,
  };
}
